(function () {
  // Prefer the carousel's own width over window.innerWidth so theme-editor /
  // responsive previews that shrink the iframe still get 1 card on mobile.
  function cardsPerPage(root) {
    var viewport = root.querySelector('.pdp-medical-team__viewport');
    var width = (viewport && viewport.clientWidth) || root.clientWidth || 0;

    if (width < 1) {
      if (window.matchMedia('(max-width: 767px)').matches) return 1;
      if (window.matchMedia('(max-width: 1024px)').matches) return 2;
      return 4;
    }

    if (width < 560) return 1;
    if (width < 900) return 2;
    return 4;
  }

  function initCarousel(root) {
    var track = root.querySelector('.pdp-medical-team__cards');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.pdp-medical-team__card'));
    var prev = root.querySelector('.pdp-medical-team__arrow--prev');
    var next = root.querySelector('.pdp-medical-team__arrow--next');
    var dotsWrap = root.querySelector('.pdp-medical-team__dots');
    if (!track || !cards.length) return null;

    var page = 0;
    var perPage = cardsPerPage(root);
    var pageCount = 1;
    var touchStartX = null;
    var touchStartY = null;

    function render() {
      perPage = cardsPerPage(root);
      pageCount = Math.max(1, Math.ceil(cards.length / perPage));
      page = Math.min(page, pageCount - 1);

      root.style.setProperty('--pdp-cards-per-page', perPage);
      // Each page of cards is exactly 100% of the track, then a flex `gap`
      // sits before the next page. Plain -100% undershoots by that gap, which
      // clips the right edge of every card after the first.
      track.style.transform =
        page === 0
          ? 'translateX(0)'
          : 'translateX(calc(' + page + ' * (-100% - var(--pdp-card-gap))))';


      // Cards on hidden pages stay out of the tab order.
      cards.forEach(function (card, i) {
        var onPage = Math.floor(i / perPage) === page;
        var trigger = card.querySelector('.pdp-medical-team__card-trigger');
        card.setAttribute('aria-hidden', onPage ? 'false' : 'true');
        if (trigger) trigger.tabIndex = onPage ? 0 : -1;
      });

      if (prev) prev.disabled = page === 0;
      if (next) next.disabled = page >= pageCount - 1;
      root.classList.toggle('is-single-page', pageCount <= 1);

      if (dotsWrap) {
        if (dotsWrap.childElementCount !== pageCount) {
          dotsWrap.replaceChildren();
          for (var i = 0; i < pageCount; i++) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'pdp-medical-team__dot';
            dot.setAttribute('role', 'tab');
            dot.setAttribute('aria-label', 'Page ' + (i + 1));
            dot.dataset.page = i;
            dotsWrap.appendChild(dot);
          }
        }
        Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
          var active = i === page;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }
    }

    function goTo(index) {
      page = Math.max(0, Math.min(index, pageCount - 1));
      render();
    }

    if (prev) prev.addEventListener('click', function () { goTo(page - 1); });
    if (next) next.addEventListener('click', function () { goTo(page + 1); });
    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (event) {
        var dot = event.target.closest('.pdp-medical-team__dot');
        if (dot) goTo(parseInt(dot.dataset.page, 10) || 0);
      });
    }

    // Snap whole pages on swipe so cards never rest halfway between slides.
    track.addEventListener('touchstart', function (event) {
      if (!event.touches.length) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });

    track.addEventListener('touchend', function (event) {
      if (touchStartX == null || !event.changedTouches.length) return;
      var dx = event.changedTouches[0].clientX - touchStartX;
      var dy = event.changedTouches[0].clientY - touchStartY;
      touchStartX = null;
      touchStartY = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      if (dx < 0) goTo(page + 1);
      else goTo(page - 1);
    }, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(render, 150);
    });

    render();
    return { cards: cards };
  }

  function initModal(root, cards) {
    var modal = root.querySelector('[data-pdp-medical-team-modal]');
    if (!modal) return;

    var dialog = modal.querySelector('.pdp-medical-team__modal-dialog');
    var content = modal.querySelector('[data-modal-content]');
    var lastTrigger = null;

    function open(card, trigger) {
      var payload = card.querySelector('[data-member-payload]');
      if (!payload || !content) return;

      var clone = payload.cloneNode(true);
      clone.removeAttribute('hidden');
      clone.removeAttribute('data-member-payload');
      content.replaceChildren(clone);

      lastTrigger = trigger;
      modal.removeAttribute('hidden');
      // Let the closed state paint first so the open transition runs.
      setTimeout(function () {
        modal.classList.add('is-open');
      }, 20);
      document.body.classList.add('pdp-medical-team-modal-open');
      if (dialog) dialog.focus();
    }

    function close() {
      if (modal.hasAttribute('hidden')) return;
      modal.classList.remove('is-open');
      document.body.classList.remove('pdp-medical-team-modal-open');
      modal.setAttribute('hidden', '');
      if (content) content.replaceChildren();
      if (lastTrigger) lastTrigger.focus();
      lastTrigger = null;
    }

    cards.forEach(function (card) {
      var trigger = card.querySelector('[data-member-open]');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        open(card, trigger);
      });
    });

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-modal-close]')) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  }

  function init(root) {
    if (!root || root.__pdpMedicalTeamInit) return;
    root.__pdpMedicalTeamInit = true;

    var carousel = initCarousel(root);
    if (carousel) initModal(root.closest('.pdp-medical-team') || root, carousel.cards);
  }

  function initAll() {
    document.querySelectorAll('[data-pdp-medical-team]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-pdp-medical-team]');
    if (root) init(root);
  });
})();
